<script>
    import { TokenStore } from "$/stores/TokenStore";
    import { getEffectivePricingPlan } from "$/utils/Utils";
    import AuthorizedLayout from "../_templates/AuthorizedLayout.svelte";
    import MetaTags from "../_templates/MetaTags.svelte";
    import { onMount } from "svelte";
    import { TenantStore } from "$/stores/TenantStore";

    let pricingPlan = null;

    $: decodedToken = $TokenStore?.decodedToken;
    $: hasCopilotBetaRole = false;

    $: {
        let authorities = decodedToken?.user.tenantAuthorities;

        if (authorities && $TenantStore) {
            let activeTenantAuthority = authorities[$TenantStore.active.id];
            if (activeTenantAuthority) {
                hasCopilotBetaRole =
                    activeTenantAuthority.find(
                        (authority) =>
                            authority.authority === "ROLE_COPILOT_BETA",
                    ) !== undefined;
            }
        }
    }
    // We need to load the tenant store in cases when the user comes directly to the copilot page via url,
    // the store is needed for searching topics and loading notifications from app bar
    onMount(async () => {
        if (!$TenantStore) {
            await TenantStore.load();
        }
        pricingPlan = getEffectivePricingPlan($TenantStore.active);
    });
</script>

<MetaTags></MetaTags>

<AuthorizedLayout>
    {#if pricingPlan != null && decodedToken}
        {#if (hasCopilotBetaRole && pricingPlan !== -1) || pricingPlan === 2}
            <slot></slot>
        {:else}
            {void (() => {
                window.location.href = "https://collabwriting.com/copilot";
            })() || ""}
        {/if}
    {/if}

    <!-- Intercom login user -->
    <!-- NOTE: void ***** || "" is added because without it svelte just prints undefined -->
    {void window.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: "xzk7pqs8",
        email: $TokenStore.user.email,
    }) || ""}
</AuthorizedLayout>
